import { Close } from "@mui/icons-material";
import { Box, Dialog, Typography } from "@mui/material";
import styles from "../ExpenseRequest.module.scss";
import { useFormik } from "formik";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomRequiredInputLabel,
  CustomTextFeild,
} from "../../../common/StyledComponents/StyledFields";
import { textFieldStyles } from "./CreateExpenseRequest";
import ButtonLoader from "../../../common/ButtonLoader/ButtonLoader";
import { object, string } from "yup";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../../../infrastructure/backendService";
import apiPath from "../../../../config/apiPaths.json";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import ErrorPopup from "../../../common/ErrorPopup";
import constants from "../../../../config/constants.json";
import SuccessPopup from "../../../devotee/donation/successPopup";
import CustomSelectField from "../../../common/CustomSelectField/CustomSelectField";

const AddVendorDialog = (props: any) => {
  const { handleClose, open, updateVendor, vendorId } = props;

  const [zipcodeError, setZipcodeError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [valueChanged, setValueChanged] = useState(false);
  const [statesList, setStatesList] = useState<any[]>([]);

  const initialValues = {
    vendorName: "",
    address: "",
    // address2: "",
    city: "",
    state: "",
    zipcode: "",
  };

  const validationSchema = object().shape({
    vendorName: string().trim().required("Vendor name is required"),
    address: string().trim().required("Address is required"),
    city: string().trim().required("City is required"),
    state: string().trim().required("State is required"),
    zipcode: string()
      .trim()
      .required("Zipcode is required")
      .matches(/^\d{5}(-\d{4})?$/, "Invalid zipcode"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit(values) {
      if (valueChanged) {
        zipCodeApi(true);
      } else {
        if (updateVendor) {
          handleUpdateVendor(values);
        } else {
          handleAddVendor(values);
        }
      }
    },
    enableReinitialize: true,
  });

  const fetchAllStatesList = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.findAllStates,
      includeToken: true,
      params: {
        size: 500,
        sortBy: "stateName",
      },
    })
      .then((res) => {
        setStatesList(res?.data?.content);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup showMessage={catchErrorMessageHandler(err)} />
        );
      });
  };

  useEffect(() => {
    fetchAllStatesList();
  }, []);

  useEffect(() => {
    if (updateVendor) {
      apiRequest({
        method: "GET",
        endpoint: `${apiPath.templeVendors}/${vendorId}`,
        includeToken: true,
      })
        .then((res) => {
          const vendorDetails = res?.data;
          formik.setFieldValue("vendorName", vendorDetails?.vendorName);
          formik.setFieldValue("address", vendorDetails?.address);
          // formik.setFieldValue("address2", vendorDetails?.address2);
          formik.setFieldValue("city", vendorDetails?.city);
          formik.setFieldValue("state", vendorDetails?.state);
          formik.setFieldValue("zipcode", vendorDetails?.zipcode);
        })
        .catch((err) => {
          setIsLoading(false);
          toast.custom(
            <ErrorPopup showMessage={catchErrorMessageHandler(err)} />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        });
    }
  }, [updateVendor]);

  const handleChange = (field: string, value: any) => {
    formik.setFieldValue(field, value);
  };

  const handleAddVendor = (values: any) => {
    setIsLoading(true);
    const vendorName = values?.vendorName;
    const payload = {
      ...values,
      vendorName: vendorName?.[0]?.toUpperCase() + vendorName?.slice(1),
      country: "USA",
    };
    apiRequest({
      method: "POST",
      endpoint: apiPath.templeVendors,
      includeToken: true,
      body: payload,
    })
      .then((res) => {
        props?.handleSelectNewVendor(res?.data);
        toast.custom(
          <SuccessPopup
            headerMessage="Add Vendor"
            showMessage={`Successfully added vendor ${values?.vendorName}`}
            isDurationDisabled={true}
          />
        );
        handleCloseDialog();
      })
      .catch((err) => {
        setIsLoading(false);
        toast.custom(
          <ErrorPopup showMessage={catchErrorMessageHandler(err)} />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleUpdateVendor = (values: any) => {
    setIsLoading(true);
    const vendorName = values?.vendorName;
    const payload = {
      ...values,
      vendorName: vendorName?.[0]?.toUpperCase() + vendorName?.slice(1),
      country: "USA",
      id: vendorId,
    };
    apiRequest({
      method: "PUT",
      endpoint: `${apiPath.templeVendors}/${vendorId}`,
      includeToken: true,
      body: payload,
    })
      .then((res) => {
        props?.handleSetUpdatedVendor?.(res?.data);
        toast.custom(
          <SuccessPopup
            headerMessage="Update Vendor"
            showMessage={`Successfully updated the vendor details`}
            isDurationDisabled={true}
          />
        );
        handleCloseDialog();
      })
      .catch((err) => {
        setIsLoading(false);
        toast.custom(
          <ErrorPopup showMessage={catchErrorMessageHandler(err)} />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleCloseDialog = () => {
    handleClose();
    setZipcodeError("");
    formik.resetForm();
    setIsLoading(false);
  };

  const zipCodeApi = (addVendor = false) => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cityAndStateApi,
      params: {
        zip: formik.values.zipcode,
      },
    })
      .then((res) => {
        setValueChanged(false);
        // formik.setTouched({
        //   ...formik.touched,
        //   zipcode: true,
        // });
        formik.setFieldValue("city", res?.data?.city);
        formik.setFieldValue("state", res?.data?.stateId);
        setTimeout(() => {
          formik.setFieldError("city", "");
          formik.setFieldError("state", "");
        }, 0);
        setZipcodeError("");
        if (addVendor) {
          handleAddVendor(formik.values);
        }
      })
      .catch((err) => {
        setValueChanged(false);
        // formik.setFieldValue("city", "");
        // formik.setFieldValue("state", "");
        // formik.setTouched({
        //   ...formik.touched,
        //   zipcode: true,
        // });
        // setZipcodeError("Invalid zipcode");
      });
  };

  const renderFieldsComponent = () => {
    return (
      <Box>
        <Box
          sx={{
            display: { xs: "block", sm: "flex" },
            columnGap: { xs: "0px", sm: "20px" },
          }}
        >
          <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
            {CustomRequiredInputLabel("Vendor Name", true)}
            <CustomTextFeild
              fullWidth
              required
              value={formik.values.vendorName}
              sx={textFieldStyles.textField}
              onChange={formik.handleChange}
              name="vendorName"
              placeholder="Enter vendor name"
            />
            {formik.touched.vendorName && formik?.errors?.vendorName ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {formik?.errors?.vendorName}
              </Typography>
            ) : (
              ""
            )}
          </Box>
          <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
            {CustomRequiredInputLabel("Address", true)}
            <CustomTextFeild
              fullWidth
              required
              value={formik.values.address}
              sx={textFieldStyles.textField}
              onChange={formik.handleChange}
              name="address"
              placeholder="Enter address"
            />
            {formik.touched.address && formik?.errors?.address ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {formik?.errors?.address}
              </Typography>
            ) : (
              ""
            )}
          </Box>
        </Box>
        <Box
          sx={{
            display: { xs: "block", sm: "flex" },
            columnGap: { xs: "0px", sm: "20px" },
            mt: "15px",
          }}
        >
          {/* <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
            {CustomRequiredInputLabel("Address 2", false)}
            <CustomTextFeild
              fullWidth
              required
              value={formik.values.address2}
              sx={textFieldStyles.textField}
              onChange={formik.handleChange}
              name="address2"
              placeholder="Enter address 2"
            />
          </Box> */}
          <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
            {CustomRequiredInputLabel("Zipcode", true)}
            <CustomTextFeild
              fullWidth
              required
              value={formik.values.zipcode}
              sx={textFieldStyles.textField}
              onChange={(e) => {
                const value = e.target.value
                  .replace(/[^\d-]/g, "")
                  .slice(0, 10);
                formik.setFieldValue("zipcode", value);
              }}
              onBlur={() => zipCodeApi()}
              name="zipcode"
              placeholder="Enter zipcode"
            />
            {((formik.touched.zipcode && formik?.errors?.zipcode) ||
              zipcodeError) && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {formik?.errors?.zipcode || zipcodeError}
              </Typography>
            )}
          </Box>
          <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
            {CustomRequiredInputLabel("City", true)}
            <CustomTextFeild
              fullWidth
              required
              value={formik.values.city}
              sx={{
                ...textFieldStyles.textField,
                // "& .MuiInputBase-input": { cursor: "not-allowed" },
              }}
              onChange={formik.handleChange}
              name="city"
              placeholder="Enter city"
            />
            {formik.touched.city && formik?.errors?.city ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {formik?.errors?.city}
              </Typography>
            ) : (
              ""
            )}
          </Box>
        </Box>
        <Box
          sx={{
            display: { xs: "block", sm: "flex" },
            columnGap: { xs: "0px", sm: "20px" },
            mt: "15px",
          }}
        >
          <Box sx={{ width: { xs: "100%", sm: "calc(50% - 10px)" } }}>
            {CustomRequiredInputLabel("State", true)}
            <CustomSelectField
              handleDropdownChange={handleChange}
              errorMessage={formik.touched.state ? formik?.errors?.state : ""}
              dropDownList={statesList}
              value={formik.values.state}
              fieldName="state"
              placeholder="Select state"
              optionLabel="stateName"
              optionValue="stateCode"
            />
          </Box>
        </Box>
      </Box>
    );
  };

  const renderButtonsComponent = () => {
    return (
      <Box mt="20px">
        <CommonButton onClick={() => formik.handleSubmit()} sx={{ mr: "10px" }}>
          <ButtonLoader
            isBtnLoading={isLoading}
            btnText={updateVendor ? "Update" : "Add"}
          />
        </CommonButton>
        <CommonOutlinedButton onClick={handleCloseDialog}>
          <ButtonLoader isBtnLoading={false} btnText={"Cancel"} />
        </CommonOutlinedButton>
      </Box>
    );
  };

  return (
    <Dialog
      onClose={handleCloseDialog}
      open={open}
      PaperProps={{
        sx: {
          width: { xs: "100%", md: "710px" },
          maxWidth: { xs: "100%", sm: "710px" },
          margin: { xs: "10px", sm: "20px" },
        },
      }}
    >
      <Box
        className={styles.add_vendor_main_container}
        sx={{
          width: "100%",
        }}
      >
        <Box className={styles.dialog_title_container}>
          <Typography className={styles.title}>
            {updateVendor ? "Update Vendor" : "Add Vendor"}
          </Typography>
          <Close
            sx={{ color: "white", cursor: "pointer" }}
            onClick={handleCloseDialog}
          />
        </Box>
        <Box className={styles.dialog_inner_container}>
          {renderFieldsComponent()}
          {renderButtonsComponent()}
        </Box>
      </Box>
    </Dialog>
  );
};

export default AddVendorDialog;
